export const DURATION = {
    min: 1,
    max: 1440,
}

export const THRESHOLD = {
    min: 0,
    max: 999,
}

export const COUNTER = {
    min: 1,
    max: 1440,
}

export const UNLOCK_ALL_STATUS = {
    INITIAL: 0,
    IN_PROGRESS: 1,
    SUCCESS: 2,
}



// WEBPACK FOOTER //
// ./web/js/administration/lockoutPolicy/constants.js